import Vue from 'vue'

// https://github.com/alfhen/vue-cookie
import VueCookie from 'vue-cookie'

Vue.use(VueCookie)
